import React, { useMemo } from 'react';
import { getPictureSrc, getPictureCaption, formatDateFr } from '../ipHelpers';

export default function IPPhotosTab({ visitCalls, picturesByCallId, onOpenPhotos }) {
  // Flatten all visible pictures across visits, keeping their visit context
  const items = useMemo(() => {
    const out = [];
    visitCalls.forEach((call) => {
      const pics = picturesByCallId[call.id] || [];
      pics.forEach((pic) => out.push({ pic, call }));
    });
    return out;
  }, [visitCalls, picturesByCallId]);

  if (items.length === 0) {
    return <p className="text-gray-500 dark:text-gray-400 italic text-center py-8">Aucune photo disponible.</p>;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
      {items.map(({ pic, call }, idx) => {
        const src = getPictureSrc(pic);
        if (!src) return null;
        const caption = getPictureCaption(pic);
        return (
          <button
            key={`${call.id}-${idx}`}
            type="button"
            onClick={() => onOpenPhotos(call.id, picturesByCallId[call.id] || [], `Visite #${call.id}`)}
            className="focus:outline-none text-left"
          >
            <div className="relative w-full h-36 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700">
              <img src={src} alt={caption || 'photo'} loading="lazy" className="w-full h-full object-cover" />
              {caption && (
                <div className="absolute inset-x-0 bottom-0 bg-black/60 text-[11px] text-white px-2 py-1 leading-tight line-clamp-2">
                  {caption}
                </div>
              )}
            </div>
            <div className="text-[11px] text-gray-400 dark:text-gray-500 mt-1">{formatDateFr(call.date, { day: '2-digit', month: 'short', year: 'numeric' })}</div>
          </button>
        );
      })}
    </div>
  );
}
